module.exports = __webpack_public_path__ + "img/background-invite-new-user@2x.13b5c07e.jpg";